import Icon from '~/src/common/components/Icon/Icon';
import I18n from '~/src/common/services/I18n/I18n';
import { formatPrice } from '~/src/common/utils/prices';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  className?: string;
  recipe: GetRecipeByIdOrSlug200;
  pricePerServing: number | undefined;
}

export const RecipePreparationInfos = (props: Props) => (
  <S.Root className={props.className}>
    <div>
      <Icon name="cooking-hat" size={24} />
      <p>{I18n.t('recipe-screen.preparation')}</p>
      <p>{I18n.t('recipe-screen.duration-time', { duration: props.recipe.preparationTime })}</p>
    </div>
    <div>
      <Icon name="saucepan" size={24} />
      <p>{I18n.t('recipe-screen.cooking')}</p>
      <p>{I18n.t('recipe-screen.duration-time', { duration: props.recipe.cookingTime })}</p>
    </div>
    <div>
      <Icon name="euro-normal" size={24} />
      <p>{I18n.t('recipe-screen.portion')}</p>
      <p>{props.pricePerServing ? formatPrice(props.pricePerServing) : '-'}</p>
    </div>
  </S.Root>
);
